export default "<!-- <hello name=\"{{ name }}\"></hello> -->\n <div id = \"container\">\n<div class = \"svg\" #chart></div>\n<div id = \"tag\"></div>\n</div>\n"